import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Select, Tag } from "antd";
import styled from "styled-components";

export const StyledTag = styled(Tag)`
  color: #ff4d4f;
  background-color: transparent;
  border: none;
  padding: 0px;
`;

export const CardBody = styled.div`
  display: inline-block;
  width: 100%;
`;

export const PageContentCard = styled(Card)`
  width: 100%;
  .ant-card-body {
    height: 100%;
  }
`;

export const GrayCard = styled(Card)`
  > .ant-card-head {
    background: #515355;
    border-left: 5px solid #db011c;

    .ant-card-head-title {
      color: #fff;
    }
  }
`;

export const GreenIcon = styled(FontAwesomeIcon)`
  color: #008745;
`;

export const RedIcon = styled(FontAwesomeIcon)`
  color: #ad0015;
`;

export const SearchProject = styled.div`
  align-items: center;
`;
export const FilterWrapper = styled.div`
  padding: 8px;
`;

export const StyledErrorMessage = styled.div`
  color: red;
`;

export const SearchInput = styled.div`
  width: 188px;
  margin-bottom: 8px;
  display: block;
`;
export const FilterDropdown = styled(Select)`
  width: 300px;
  margin-bottom: 8px;
  display: block;
`;

const tableIconActiveStyle = (isActive) => {
  const activeColor = isActive ? "#1890ff" : undefined;
  return activeColor;
};

export const StyledSearchIcon = styled(FontAwesomeIcon)`
  color: ${({ $active }) => tableIconActiveStyle($active)};
`;

export const StyledFilterIcon = styled(FontAwesomeIcon)`
  color: ${({ $active }) => tableIconActiveStyle($active)};
`;

export const HorizontalScrollBox = styled.div`
  overflow: auto hidden;
  display: flex;
`;

export const FullHeightCard = styled(Card)`
  height: 100%;
`;

export const SmallCard = styled(Card)`
  width: 350px;
`;
